module.exports = "<div class=\"q-col-6 q-no-pad q-text-center page-data-info\"> {%= pageData %} </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/lookupTable/html/pageDataInfo.html
// module id = 1158
// module chunks = 1